import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectShipment } from "../shipmentSlice";
import { selectShipmentBoxes } from "./shipmentItemsSlice";
import { useTranslation } from "react-i18next";

const Upper = () => {
    const {t} = useTranslation();
    const shipment = useSelector(selectShipment);
    const shipmentBoxes = useSelector(selectShipmentBoxes);

    const shipemetItemsTotalPhysicalWeight = useMemo(() => {
        let totalWeight = 0;
        shipmentBoxes.forEach((box) => {
            totalWeight += box.weight.toFixed(2) * 1;
        });
        return totalWeight.toFixed(2) * 1;
    }, [shipmentBoxes]);

    const shipmentItemsTotalCrossWeight = useMemo(() => {
        let totalWeight = 0;
        shipmentBoxes.forEach((box) => {
            let volumeWeight = (box.length * box.width * box.height) / 5000;
            totalWeight += Math.max(volumeWeight, box.weight).toFixed(2) * 1;
        });
        return totalWeight.toFixed(2) * 1;
    }, [shipmentBoxes]);

    return (
        <div className="text-left mb-6">
            <div className="text-xl text-center text-emerald-600 font-bold mb-2">
                {t("shipment.items.title")}
            </div>
            <div className="text-xs sm:text-base flex gap-x-10 gap-y-2 flex-wrap">
                <div>
                    {t("shipment.items.stats.worth")}:{" "}
                    <span className="font-medium">
                        {" " + shipment["price-TRY"]}₺
                    </span>{" "}
                    |{" "}
                    <span className="font-medium">
                        {" " + shipment["price-USD"]}$
                    </span>{" "}
                    |{" "}
                    <span className="font-medium">
                        {" " + shipment["price-EUR"]}€
                    </span>
                </div>
                {
                    shipment && !shipment["bill-id"] &&
                    <div className="flex flex-wrap">
                        <div>
                            {t("shipment.items.stats.physical_weight")}:
                            <span className="font-medium">
                                {" " + shipemetItemsTotalPhysicalWeight} kg
                            </span>{" "} |
                        </div>
                        <div>
                            {t("shipment.items.stats.cross_weight")}:
                            <span className="font-medium">
                                {" " + shipmentItemsTotalCrossWeight} kg
                            </span>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default Upper;
